import { BrowserStorage } from "@axazara/shuriken";

export const PersistentStorage = new BrowserStorage();

export const EphemeralStorage = new BrowserStorage("AXAZARA_", sessionStorage);
